module.exports = __webpack_public_path__ + "static/media/460.32ede53b.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/460.png
// module id = 757
// module chunks = 0